import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CloudAccountPoolService } from '../../service/pool.service';

@Component({
  selector: 'app-cloud-account-pool-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class ConsoleCloudAccountPoolSelectComponent implements OnInit {

  @Input() pools: any;
  @Input() vendor: string;

  vmPoolSelectionStateText = 'cloud-account.pool.select.content.select-pool';

  vmPoolId: string;

  vmPool: any;

	@ViewChild('selectForm', {static: false}) selectForm: NgForm;

  constructor(
    private poolService: CloudAccountPoolService
  ) {
    this.vmPool = {};
  }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.pools && this.pools.length > 0) {
      this.pools.forEach((pool: any) => {
        if (pool.usage === 'Server') {
          this.vmPoolId = pool.poolId;
        }
      });
    }

    if (this.vmPoolId) {
      this.poolService.get(this.vmPoolId).subscribe(pool => {
        if (pool) {
          this.vmPool = pool;
        }
        this.vmPoolSelectionStateText = 'cloud-account.pool.select.content.pool-selected';
      });  
    }
  }

  validateForm(messages: any): any {
		if (!this.selectForm.valid) {
			if (this.selectForm.controls) {
				for (const control in this.selectForm.controls) {
					this.selectForm.controls[control].markAsTouched();
				}
			}
      return null;
    }

    return this.vmPool;
  }

  doBrowseVMPool() {
    this.poolService.doBrowsePool(this.vendor).subscribe(selectedPool => {
      this.vmPool = selectedPool.data[0].getData();
      this.vmPoolSelectionStateText = 'cloud-account.pool.select.content.pool-selected';
    });
  }

}
